module.exports = __webpack_public_path__ + "img/all_persons-small.6db17b28.webp";